import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';

export const LeasePill: React.FC<{ leaseStatus: string }> = ({ leaseStatus }) => {
  if (!leaseStatus) return null;

  if (leaseStatus === 'Current Lease') {
    return (
      <View style={styles.currentWrap}>
        <View style={styles.currentInner}>
          <HouseIcon />
          <Text style={styles.currentText}>{leaseStatus}</Text>
        </View>
      </View>
    );
  }

  return (
    <View style={styles.otherWrap}>
      <Text style={styles.otherText}>{leaseStatus}</Text>
    </View>
  );
};

const HouseIcon: React.FC = () => {
  const Icon = RESIDENTS_SVG_COMPONENTS.HOUSE as any;
  if (!Icon) return null;
  return <Icon width={14} height={14} color={'#E5BFE9'} style={{ marginRight: 6 }} />;
};

const styles = StyleSheet.create({
  currentWrap: {
    alignSelf: 'flex-start',
    borderRadius: 999,
    marginBottom: 4,
    backgroundColor: 'transparent',
  },
  currentInner: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 999,
    backgroundColor: 'rgba(229, 191, 233, 0.15)',
  },
  currentText: {
    color: '#E5BFE9',
    fontSize: 12,
    fontWeight: '700',
  },
  otherWrap: {
    alignSelf: 'flex-start',
    borderRadius: 999,
    marginBottom: 8,
    backgroundColor: 'rgba(255,255,255,0.10)',
  },
  otherText: {
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
    fontSize: 12,
    paddingHorizontal: 10,
    paddingVertical: 6,
  },
});


